import { render } from "./RatingComponent.vue?vue&type=template&id=ebca1d0e&scoped=true"
import script from "./RatingComponent.vue?vue&type=script&lang=js"
export * from "./RatingComponent.vue?vue&type=script&lang=js"

import "./RatingComponent.vue?vue&type=style&index=0&id=ebca1d0e&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebca1d0e"]])

export default __exports__